// extracted by mini-css-extract-plugin
module.exports = {"visual":"visual_visual__GwuVa","noImage":"visual_noImage__3Miw_","hasImage":"visual_hasImage__1a9_u"};